// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* payment-success.css */
.success-page-wrapper {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.success-card-main {
  background: white;
  border-radius: 8px;
  padding: 50px 40px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.success-icon-wrapper {
  margin-bottom: 30px;
}

.checkmark-container {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  border-radius: 50%;
  background: #10b981;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.checkmark-icon {
  width: 50px;
  height: 50px;
  stroke: white;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  animation: drawCheck 0.5s ease-out 0.3s forwards;
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
}

@keyframes drawCheck {
  to {
    stroke-dashoffset: 0;
  }
}

.success-title-main {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.success-subtitle-main {
  font-size: 15px;
  color: #666;
  margin-bottom: 35px;
}

.success-details-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 30px;
}

.success-detail-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 18px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  text-align: left;
}

.success-detail-icon {
  width: 40px;
  height: 40px;
  background: #ff6b00;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.success-detail-icon svg {
  width: 22px;
  height: 22px;
  stroke: white;
  fill: none;
}

.success-detail-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}

.success-detail-label {
  font-size: 13px;
  color: #666;
  font-weight: 500;
}

.success-detail-value {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.success-info-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #fff8f0;
  border: 1px solid #ffe4cc;
  border-radius: 6px;
  margin-bottom: 30px;
  text-align: left;
}

.success-info-alert svg {
  flex-shrink: 0;
  stroke: #ff6b00;
  width: 20px;
  height: 20px;
  margin-top: 2px;
}

.success-info-alert p {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

.success-actions-container {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.success-btn-primary,
.success-btn-secondary {
  flex: 1 1;
  padding: 14px 20px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.success-btn-primary {
  background: linear-gradient(135deg, #ff6b00 0%, #ff8c3a 100%);
  color: white;
}

.success-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(255, 107, 0, 0.3);
}

.success-btn-secondary {
  background: white;
  border: 2px solid #ff6b00;
  color: #ff6b00;
}

.success-btn-secondary:hover {
  background: #fff8f0;
}

.redirect-info-text {
  font-size: 13px;
  color: #999;
  margin-top: 15px;
}

@media (max-width: 640px) {
  .success-card-main {
    padding: 35px 25px;
  }

  .success-title-main {
    font-size: 24px;
  }

  .success-actions-container {
    flex-direction: column;
  }

  .success-detail-card {
    padding: 15px;
  }

  .success-detail-value {
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Advertisement/Stripe/payment-success.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sEAAsE;AACxE;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,gDAAgD;EAChD,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* payment-success.css */\r\n.success-page-wrapper {\r\n  min-height: 100vh;\r\n  background: #f5f5f5;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\r\n}\r\n\r\n.success-card-main {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 50px 40px;\r\n  max-width: 600px;\r\n  width: 100%;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);\r\n  text-align: center;\r\n}\r\n\r\n.success-icon-wrapper {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.checkmark-container {\r\n  width: 100px;\r\n  height: 100px;\r\n  margin: 0 auto;\r\n  position: relative;\r\n  border-radius: 50%;\r\n  background: #10b981;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  animation: scaleIn 0.5s ease-out;\r\n}\r\n\r\n@keyframes scaleIn {\r\n  0% {\r\n    transform: scale(0);\r\n  }\r\n  50% {\r\n    transform: scale(1.1);\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.checkmark-icon {\r\n  width: 50px;\r\n  height: 50px;\r\n  stroke: white;\r\n  stroke-width: 3;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n  fill: none;\r\n  animation: drawCheck 0.5s ease-out 0.3s forwards;\r\n  stroke-dasharray: 100;\r\n  stroke-dashoffset: 100;\r\n}\r\n\r\n@keyframes drawCheck {\r\n  to {\r\n    stroke-dashoffset: 0;\r\n  }\r\n}\r\n\r\n.success-title-main {\r\n  font-size: 28px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.success-subtitle-main {\r\n  font-size: 15px;\r\n  color: #666;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.success-details-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.success-detail-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  padding: 18px;\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  text-align: left;\r\n}\r\n\r\n.success-detail-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  background: #ff6b00;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.success-detail-icon svg {\r\n  width: 22px;\r\n  height: 22px;\r\n  stroke: white;\r\n  fill: none;\r\n}\r\n\r\n.success-detail-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  flex: 1;\r\n}\r\n\r\n.success-detail-label {\r\n  font-size: 13px;\r\n  color: #666;\r\n  font-weight: 500;\r\n}\r\n\r\n.success-detail-value {\r\n  font-size: 16px;\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.success-info-alert {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  padding: 16px;\r\n  background: #fff8f0;\r\n  border: 1px solid #ffe4cc;\r\n  border-radius: 6px;\r\n  margin-bottom: 30px;\r\n  text-align: left;\r\n}\r\n\r\n.success-info-alert svg {\r\n  flex-shrink: 0;\r\n  stroke: #ff6b00;\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.success-info-alert p {\r\n  font-size: 14px;\r\n  color: #666;\r\n  margin: 0;\r\n  line-height: 1.6;\r\n}\r\n\r\n.success-actions-container {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.success-btn-primary,\r\n.success-btn-secondary {\r\n  flex: 1;\r\n  padding: 14px 20px;\r\n  border-radius: 6px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  border: none;\r\n}\r\n\r\n.success-btn-primary {\r\n  background: linear-gradient(135deg, #ff6b00 0%, #ff8c3a 100%);\r\n  color: white;\r\n}\r\n\r\n.success-btn-primary:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 20px rgba(255, 107, 0, 0.3);\r\n}\r\n\r\n.success-btn-secondary {\r\n  background: white;\r\n  border: 2px solid #ff6b00;\r\n  color: #ff6b00;\r\n}\r\n\r\n.success-btn-secondary:hover {\r\n  background: #fff8f0;\r\n}\r\n\r\n.redirect-info-text {\r\n  font-size: 13px;\r\n  color: #999;\r\n  margin-top: 15px;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .success-card-main {\r\n    padding: 35px 25px;\r\n  }\r\n\r\n  .success-title-main {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .success-actions-container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .success-detail-card {\r\n    padding: 15px;\r\n  }\r\n\r\n  .success-detail-value {\r\n    font-size: 15px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
